<template>
  <div class="row h-100 m-0">
    <div class="col-2 h-100">
      <div
        class="text-center"
        style="height: 50px"
      >
        <h3 class="p-2">
          {{ globalStore.eventID }}
        </h3>
      </div>
      <perfect-scrollbar
        class="overflow-hidden"
        style="height: calc(100vh - 50px)"
        :options="{suppressScrollX: true, wheelPropagation: true}"
      >
        <div
          id="accordionList"
          class="accordion"
        >
          <div
            v-for="(contextElement, contextIndex) in translationsStore.translations"
            :key="contextIndex"
            class="accordion-item"
          >
            <h2
              :id="`heading-${contextIndex}`"
              class="accordion-header"
            >
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#collapse-${contextIndex}`"
                aria-expanded="true"
                :aria-controls="`collapse-${contextIndex}`"
              >
                {{ contextIndex }}
              </button>
            </h2>
            <div
              :id="`collapse-${contextIndex}`"
              class="accordion-collapse collapse"
              :aria-labelledby="`heading-${contextIndex}`"
              data-bs-parent="#accordionList"
            >
              <div class="accordion-body">
                <div
                  v-for="(element, index) in translationsStore.translations[contextIndex]"
                  :key="index"
                  style="border: 1px solid black"
                  class="px-3 my-2"
                  :class="isCurrent(index, contextIndex) ? 'bg-success' : ''"
                  @click="translationsStore.setCurrentElementAction(index, contextIndex)"
                >
                  <p class="my-3">
                    {{ index }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="col-10 vh-100">
      <div
        v-if="!translationsStore.currentElementID"
        class="vh-100 d-flex justify-content-center align-items-center"
      >
        {{ t('chooseElementLeftBarElement') }}
      </div>
      <TranslationEditor v-else />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import TranslationEditor from '../components/TranslationEditor.vue';
import useGlobalStore from '../stores/globalStore';
import useTranslationStore from '../stores/translationsStore';

const globalStore = useGlobalStore();
const translationsStore = useTranslationStore();
const { t } = useI18n();
translationsStore.getElementsAction(globalStore.eventID);

function isCurrent(elementID, contextID) {
  return elementID === translationsStore.currentElementID && contextID === translationsStore.currentContextID;
}
</script>

<style scoped>
@import 'vue3-perfect-scrollbar/style.css';

</style>
